import { useCallback } from 'react';
import { usePathname, useRouter } from 'next/navigation';
import styled from 'styled-components';
import { getLink } from '@frameio/shared/routing';
import { Button2, Text, theme } from '@frameio/vapor';
import { IconProject } from '@frameio/vapor-icons';
import TEXT from './generated/TEXT/AllProjectsButton';

export const AllProjectsButton = () => {
  const pathname = usePathname();
  const router = useRouter();
  const isAllProjectsPage = pathname === '/workspaces' || pathname === '/';
  const navigateToAllProjects = useCallback(() => {
    router.push(getLink({ page: 'workspaces', explicitWorkspacesPath: true }));
  }, [router]);
  return (
    <Container>
      <StyledButton
        aria-label={TEXT.allProjectsLinkAriaLabel}
        aria-selected={isAllProjectsPage}
        iconBefore={<IconProject color={theme.colors.icon.primary} size={24} />}
        onClick={navigateToAllProjects}
        variant="tertiary"
      >
        <Text variant="body">{TEXT.label}</Text>
      </StyledButton>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-grow: 0;
  flex-shrink: 1;
  margin-bottom: ${theme.spaces[12]};
  margin-top: ${theme.spaces[16]};
`;

const StyledButton = styled(Button2)`
  align-items: center;
  display: flex;
  flex-grow: 1;
  gap: var(--gap, var(--spaces-8));
  justify-content: flex-start;
  margin-left: ${theme.spaces[16]};
  margin-right: ${theme.spaces[16]};
  padding: 0 6px;

  &[aria-selected='true'] {
    background: ${theme.colors.background.interactive.activatedSolid};
  }
`;

TEXT.DEFINE({
  /** Button label for navigating to all projects */
  label: 'All Projects',
  /** Aria label for the all projects link */
  allProjectsLinkAriaLabel: 'All Projects Link',
});
